import { fetchIcon } from '../atomIcon';

export const atomInput = () => {
  const elements: HTMLElement[] = Array.from(
    document.querySelectorAll('[is="atom-input"]')
  );

  /** Check Input Disability and toggle isDisabled class to this elements  */
  const handleDisabled = () => {
    const checkDisabled = (
      element: HTMLElement,
      input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    ) => {
      element.classList.toggle('isDisabled', input.disabled);
    };

    elements.forEach((element) => {
      const input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement =
        Array.from(element.querySelectorAll('input, textarea, select')).map(
          (x) => {
            if (x.nodeName === 'SELECT') return <HTMLSelectElement>x;
            if (x.nodeName === 'TEXTAREA') return <HTMLTextAreaElement>x;
            return <HTMLInputElement>x;
          }
        )[0];

      checkDisabled(element, input);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'disabled') {
            checkDisabled(element, input);
          }
        });
      });

      observer.observe(input, { attributes: true });
    });
  };

  /**
   * Handle `<select>` elements
   */
  const handleSelect = async () => {
    const svg = await fetchIcon('/assets/icons/ico-chevron.svg');
    const iconWrapper = document.createElement('span');
    iconWrapper.setAttribute('is', 'atom-icon');
    iconWrapper.setAttribute('aria-hidden', 'true');
    iconWrapper.classList.add('loaded');
    iconWrapper.innerHTML = svg;

    elements
      .filter((x) => x.querySelector('select'))
      .forEach((element) => {
        element.append(iconWrapper.cloneNode(true));
      });
  };

  handleDisabled();
  handleSelect();
};
